/**
 * Shared class strings for the institutional signup wizard.
 *
 * Centralised so the ~70-field form cannot drift from the rest of the app, and
 * so every surface carries its dark-mode pair — the form this replaces was
 * hard-coded to `bg-white` / `text-[#2d2923]` and was unreadable with
 * `darkMode: 'class'` on.
 */

/** The card shell used across Profile & Settings and the org screens. */
export const CARD_SHELL =
  'border border-white bg-[rgba(255,255,255,0.32)] dark:border-[#171717] dark:bg-[rgba(23,23,23,0.72)]'

export const PAGE_TITLE =
  'font-plus-jakarta text-[28px] font-medium leading-[36px] tracking-[-0.28px] text-[#2d2923] dark:text-[#fdfdfd]'

export const SECTION_TITLE =
  'font-plus-jakarta text-[20px] font-semibold leading-[24px] tracking-[-0.2px] text-[#2d2923] dark:text-[#fdfdfd]'

export const FIELD_LABEL =
  'block font-plus-jakarta text-[14px] font-medium leading-[20px] text-[#2d2923] dark:text-[#fdfdfd] mb-1'

export const BODY_TEXT =
  'font-plus-jakarta text-[14px] font-normal leading-[20px] text-[rgba(45,41,35,0.64)] dark:text-[rgba(253,253,253,0.64)]'

export const HELP_TEXT =
  'font-plus-jakarta text-[12px] font-normal leading-[18px] text-[rgba(45,41,35,0.56)] dark:text-[rgba(253,253,253,0.56)]'

export const ERROR_TEXT = 'font-plus-jakarta text-[12px] leading-[18px] text-[#ff540c] mt-1'

/** Checkbox needs explicit dark styling: the shared atom is light-only. */
export const CHECKBOX_CLASS =
  'mt-[2px] dark:border-[rgba(253,253,253,0.32)] dark:bg-[rgba(255,255,255,0.08)] ' +
  'dark:data-[state=checked]:bg-[#fdfdfd] dark:data-[state=checked]:border-[#fdfdfd]'

export const CHECKBOX_TICK_DARK = 'dark:[&_svg]:text-[#2d2923]'
